import { useCallback } from 'react'
import { useFetchAccountUsagePolicies } from '@/account/accountQueries'
import { useAcceptTerms } from '../userQueries'
import type { AccountUsagePolicies } from '@/common/types'

interface UseTermsAndConditionsFlowResult {
    policiesResponse: AccountUsagePolicies | undefined
    policiesLoading: boolean
    policiesError: boolean
    isAccepting: boolean
    isSuccess: boolean
    error: unknown
    onSubmit: () => void
}

export function useTermsAndConditionsFlow(accountId?: string): UseTermsAndConditionsFlowResult {
    const {
        data: policiesResponse,
        isLoading: policiesLoading,
        isError: policiesError,
    } = useFetchAccountUsagePolicies(accountId)
    const acceptTerms = useAcceptTerms(() => {})

    const onSubmit = useCallback(() => {
        if (!policiesResponse?.policies.length) return

        const versionIds = policiesResponse.policies.map((p) => p.versionId)
        acceptTerms.mutate(versionIds)
    }, [policiesResponse?.policies, acceptTerms])

    return {
        policiesResponse,
        policiesLoading,
        policiesError,
        isAccepting: acceptTerms.isPending,
        isSuccess: acceptTerms.isSuccess,
        error: acceptTerms.error,
        onSubmit,
    }
}
